import { useFormik } from 'formik'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import * as Yup from 'yup'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import { Container } from '../../../assets/styles/GlobalStyle'
import Button from '../../../components/Button'
import Input from '../../../components/Input'
import Loader from '../../../components/Loader'
import ScreenHeader from '../../../components/ScreenHeader'
import { Helmet } from 'react-helmet-async'

const ResetPasswordStepTwo = () => {
  const { token = '' } = useParams()
  const [newPassword, setNewPassword] = useState('')
  const [repeatNewPassword, setRepeatNewPassword] = useState('')
  const [disableForm, setDisableForm] = useState(false)
  const [resetPasswordCreateNewPassword, { isLoading }] = api.useResetPasswordCreateNewPasswordMutation()

  const navigate = useNavigate()

  const { t } = useTranslation()

  const SendNewPassword = async () => {
    if (newPassword === repeatNewPassword) {
      try {
        await resetPasswordCreateNewPassword({
          password: newPassword,
          passwordConfirm: repeatNewPassword,
          token,
        }).unwrap()
        setDisableForm(true)
        toast.success(`${t('passwordIsUpdated')}`)
        toast.info(`${t('autoRedirectFiveSec')}`)
        // auto navigate login screen
        setTimeout(() => {
          navigate('/login')
        }, 5000)
      } catch (error: any) {
        if (error?.data?.errors?.constructor === Array) {
          const firstError = error.data.errors[0]
          const errorMessage = firstError.message
          toast.error(errorMessage)
        } else {
          toast.error(`${t('anErrorOccurred')}`)
        }
      }
    } else {
      toast.warn('The entered information does not match')
    }
  }

  // yup validations schema
  const InfoValidationSchema = Yup.object({
    newPassword: Yup.string()
      .min(8, 'Password must be 8 characters long')
      .matches(/[0-9]/, `${t('passContainNumber')}`)
      .matches(/[a-z]/, `${t('passContainLowerCase')}`)
      .matches(/[a-zA-Z]/, `${t('passContainEnglishLetters')}`)
      .matches(/[A-Z]/, `${t('passContainUpperCase')}`),
    // .matches(/[^\w]/, 'პაროლი უნდა შეიცავდეს სიმბოლოს'),
    repeatNewPassword: Yup.string().oneOf([Yup.ref('newPassword'), null], `${t('enterSamePass')}`),
  })
  // initial values
  const initialValues = {
    newPassword: newPassword || '',
    repeatNewPassword: repeatNewPassword || '',
  }
  // formi state
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: InfoValidationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log(values)
    },
  })
  //
  //
  const MainLoading = isLoading

  return MainLoading ? (
    <Loader />
  ) : (
    <>
      <Helmet>
        <title>{t('createPassword')}</title>
        <meta name="description" content={`${t('createPassword')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <ScreenHeader text={t('homePage')} url="/" />
      <Container>
        <MainWrapper>
          <LargeTitle>{t('createNewPassword')}</LargeTitle>

          <Wrapper>
            <CustomForm>
              <Input
                id="newPassword"
                label={t('enterNewPassword')}
                type="password"
                placeholder=""
                value={newPassword}
                name="newPassword"
                error={formik.errors.newPassword && formik.touched.newPassword ? true : false}
                errorText={formik.errors.newPassword}
                onBlur={formik.handleBlur}
                icon={true}
                onChange={(value) => [setNewPassword(value), formik.setFieldValue('newPassword', value)]}
                width={'fullWidth'}
                style={{ marginBottom: '24px' }}
              />

              <Input
                id="repeatNewPassword"
                label={t('repeatNewPassword')}
                type="password"
                placeholder=""
                value={repeatNewPassword}
                name="repeatNewPassword"
                error={formik.errors.repeatNewPassword && formik.touched.repeatNewPassword ? true : false}
                errorText={formik.errors.repeatNewPassword}
                onBlur={formik.handleBlur}
                icon={true}
                onChange={(value) => [setRepeatNewPassword(value), formik.setFieldValue('repeatNewPassword', value)]}
                width={'fullWidth'}
                style={{ marginBottom: '24px' }}
              />

              <Button
                onClick={SendNewPassword}
                text={t('create')}
                btnStyleType="primary"
                fullWidth={true}
                disabled={
                  (formik.isValid === true &&
                  newPassword &&
                  repeatNewPassword &&
                  repeatNewPassword.length >= 8 &&
                  newPassword.length >= 8
                    ? false
                    : true) ||
                  (disableForm && true)
                }
              />
            </CustomForm>
          </Wrapper>
        </MainWrapper>
      </Container>
    </>
  )
}
const Wrapper = styled.div`
  background-color: ${Colors.white};
  padding: 48px 64px 56px 64px;
  max-width: 528px;
  margin: 0 auto 140px auto;

  /* responsive */
  ${Responsive.mobile} {
    padding: 32px 24px 40px 24px;
    margin-bottom: 100px;
  }
`
const CustomForm = styled.div`
  margin-bottom: 25px;
`
const MainWrapper = styled.div`
  /*  */
`
const LargeTitle = styled.h1`
  font-size: 36px;
  line-height: 40px;
  color: ${Colors.primaryBlack};
  text-align: center;
  margin-top: 56px;
  margin-bottom: 56px;
  text-transform: capitalize;

  /* responsive */
  ${Responsive.tablet} {
    font-size: 24px;
    line-height: 26px;
  }

  /* responsive */
  ${Responsive.mobile} {
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 56px;
    margin-top: 56px;
  }
`

export default ResetPasswordStepTwo
